const RequiredEnvironment = {
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  PROTOCOLL: process.env.REACT_APP_PROTOCOLL,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  API_PATH: process.env.REACT_APP_API_PATH,
  FACEBOOK_API_ID: process.env.REACT_APP_FACEBOOK_API_ID,
  HONEYBADGER_API_KEY: process.env.REACT_APP_HONEYBADGER_API_KEY,
  HONEYBADGER_ENVIRONMENT: process.env.REACT_APP_HONEYBADGER_ENVIRONMENT,
  ADYEN_CHECKOUT_ENVIRONMENT: process.env.REACT_APP_ADYEN_CHECKOUT_ENVIRONMENT,
  DATOCMS_TOKEN: process.env.REACT_APP_DATOCMS_TOKEN,
  DATOCMS_URL: process.env.REACT_APP_DATOCMS_URL,
  DATOCMS_ENV: process.env.REACT_APP_DATOCMS_ENV,
  STANDINGS_ENDPOINT: process.env.REACT_APP_STANDINGS_ENDPOINT,
  FAQ_URL: process.env.REACT_APP_FAQ_URL,
  SUPPORT_URL: process.env.REACT_APP_SUPPORT_URL,
  DEFAULT_IMPRESSUM_URL: process.env.REACT_APP_DEFAULT_IMPRESSUM_URL,
  SERVICE_API_BASE_URL: process.env.REACT_APP_SERVICE_API_BASE_URL,
  HOME_URL: process.env.REACT_APP_HOME_URL,
  HOME_URL_LINK_TYPE: process.env.REACT_APP_HOME_URL_LINK_TYPE,
  VERSION: process.env.REACT_APP_VERSION
}

Object.keys(RequiredEnvironment).forEach((key) => {
  if (
    RequiredEnvironment[key as keyof typeof RequiredEnvironment] === undefined
  ) {
    throw new Error(`Environment variable ${key} is not defined`)
  }
})

const OptionalEnvironment = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL
}

const Environment = {
  // Keep optional env variables first to not overwrite required
  ...OptionalEnvironment,
  ...RequiredEnvironment
}

export { Environment }
